'use strict';

const { getHeight, getWidth } = require('../../deal/frontend/get_dimensions');

class Media {
  constructor(data, $wrapperEl) {
    this.data = data;
    this.$el = $wrapperEl.querySelector(`[data-id="${data.id}"]`);

    this.$wrapperEl = $wrapperEl;
    this.onPlayerReady = this.onPlayerReady.bind(this);
    this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
    this.startZoom = this.startZoom.bind(this);
    this.continueZoom = this.continueZoom.bind(this);
    this.finishZoom = this.finishZoom.bind(this);
  }

  getId() {
    return this.data.id;
  }

  hide() {
    this.$el.classList.remove('current-media');
    this.$el.style.opacity = 0;
    if (this.data.isVideo) {
      const playerId = this.$el.getAttribute('id');
      const id = this.data.id;
      const height = getHeight(this.$el, { margin: false });
      this.$el.outerHTML = `<div id="${playerId}" class='video-player' data-id="${id}" style="height: ${height}px"></div>`;
      this.$el = document.querySelector(`#${this.data.playerId}`);
    }
  }

  onPlayerReady(event) {
    event.target.playVideo();
  }

  onPlayerStateChange(event) {
    switch (event.data) {
      case window.YT.PlayerState.PAUSED:
        break;
      case window.YT.PlayerState.ENDED:
        break;
      default:
        break;
    }
  }

  show() {
    this.$el.classList.add('current-media');
    Object.assign(this.$el.style, {
      display: 'block',
      opacity: 1,
    });

    if (this.data.isVideo) {
      if (this.data.provider === 'YOUTUBE') {
        this.videoPlayer = new window.YT.Player(this.data.playerId, {
          height: getHeight(this.$wrapperEl, { margin: false }),
          width: getWidth(this.$wrapperEl, { margin: false }),
          videoId: this.data.url,
          playerVars: {
            rel: 0,
            showinfo: 0,
          },
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange,
          },
        });
        this.$el = document.querySelector(`#${this.data.playerId}`);
      }
    }
  }

  load() {
    if (!this.$el) {
      return null;
    }

    if (this.$el.dataset.loaded === 'true') {
      //The image has already been loaded
      return this;
    }

    this.$el.onload = () => {
      Object.assign(this.$el.style, {
        filter: 'blur(0px)',
        '-webkit-filter': 'blur(0px)',
      });
      this.$el.dataset.loaded = 'true';
    };
    this.$el.setAttribute('src', this.$el.dataset.originalImg);
    return this;
  }

  /*
  ZOOM FUNCTIONS
  */
  setUpZoom() {
    this.zoomScale = 1;
    this.inZoom = false;
    if (!this.$el.dataset.zoom) {
      this.$el.style.cursor = '';
      return false;
    }

    this.$el.removeEventListener('mouseenter', this.startZoom);
    this.$el.removeEventListener('mousemove', this.continueZoom);
    this.$el.removeEventListener('mouseleave', this.finishZoom);
    this.$el.addEventListener('mouseenter', this.startZoom);
    this.$el.addEventListener('mousemove', this.continueZoom);
    this.$el.addEventListener('mouseleave', this.finishZoom);
    return true;
  }

  startZoom(event) {
    const originalImageWidth = this.$el.naturalWidth;
    this.inZoom = true;
    this.$el.onload = () => {
      this.zoomScale = this.$el.naturalWidth / originalImageWidth;
      this.performZoomOnImage(this.zoomScale, event.offsetX, event.offsetY);
      this.$el.dataset.zoomLoaded = 'true';
    };
    this.$el.setAttribute('src', this.$el.dataset.zoom);
  }

  continueZoom(event) {
    if (!this.inZoom) {
      this.startZoom(event);
    } else {
      if (event.target.classList.contains('carousel-button')) {
        this.performZoomOnImage(1);
      } else {
        this.$el.style.cursor = 'zoom-in';
        this.performZoomOnImage(this.zoomScale, event.offsetX, event.offsetY);
      }
    }
  }

  finishZoom() {
    this.$el.style.cursor = '';
    this.$el.setAttribute('src', this.$el.dataset.originalImg);
    this.$el.onload = undefined;
    this.performZoomOnImage(1);
    this.inZoom = false;
  }

  performZoomOnImage(scale, x, y) {
    const newStyles = {
      transform: `scale(${scale})`,
    };
    if (x && y) {
      Object.assign(newStyles, {
        'transform-origin': `${x}px ${y}px`,
      });
    }
    Object.assign(this.$el.style, newStyles);
  }
}

module.exports = Media;
